import CaseDEtailParent from "./CaseDetail/CaseDetailParent";
import CaseTransferParentHome from "./CaseTransfer/CaseTransferParentHome";
import CauseListHome from "./CauseList/CauseListHome";
import OrderHome from "./Order/OrderHome";
import { useState } from "react";

const DrtCaseCauseParent = () => {
  const [relatedLink, setRelatedLink] = useState("CaseDetail");

  return (
    <main
      className="col-12 col-sm-12 col-md-12 col-lg-8 tab-one"
      role="main"
      aria-label="Case and Cause Information Section"
    >
      <nav
        className="mb-3"
        aria-label="Case navigation tabs"
      >
        <ul className="nav toptab-one" id="pills-tab" role="tablist">
          {/* Case Details */}
          <li className="nav-item" role="presentation">
            <button
              className={relatedLink === "CaseDetail" ? "nav-link active" : "nav-link"}
              id="tab-case-details"
              role="tab"
              aria-controls="panel-case-details"
              aria-selected={relatedLink === "CaseDetail"}
              onClick={() => setRelatedLink("CaseDetail")}
            >
              Case Details
            </button>
          </li>

          {/* Cause List */}
          <li className="nav-item" role="presentation">
            <button
              className={relatedLink === "CauseList" ? "nav-link active" : "nav-link"}
              id="tab-cause-list"
              role="tab"
              aria-controls="panel-cause-list"
              aria-selected={relatedLink === "CauseList"}
              onClick={() => setRelatedLink("CauseList")}
            >
              Cause List
            </button>
          </li>

          {/* Orders */}
          <li className="nav-item" role="presentation">
            <button
              className={relatedLink === "Order" ? "nav-link active" : "nav-link"}
              id="tab-order"
              role="tab"
              aria-controls="panel-order"
              aria-selected={relatedLink === "Order"}
              onClick={() => setRelatedLink("Order")}
            >
              Orders
            </button>
          </li>

          {/* Case Transfer */}
          <li className="nav-item" role="presentation">
            <button
              className={relatedLink === "CaseTransfer" ? "nav-link active" : "nav-link"}
              id="tab-case-transfer"
              role="tab"
              aria-controls="panel-case-transfer"
              aria-selected={relatedLink === "CaseTransfer"}
              onClick={() => setRelatedLink("CaseTransfer")}
            >
              Case Transfer
            </button>
          </li>
        </ul>
      </nav>

      {/* Tab Panels */}
      <section
        className="tab-content"
        id="pills-tabContent"
        aria-live="polite"
      >
        {relatedLink === "CaseDetail" && (
          <article
            className="tab-pane fade show active"
            id="panel-case-details"
            role="tabpanel"
            aria-labelledby="tab-case-details"
          >
            <CaseDEtailParent />
          </article>
        )}

        {relatedLink === "CauseList" && (
          <article
            className="tab-pane fade show active"
            id="panel-cause-list"
            role="tabpanel"
            aria-labelledby="tab-cause-list"
          >
            <CauseListHome />
          </article>
        )}

        {relatedLink === "Order" && (
          <article
            className="tab-pane fade show active"
            id="panel-order"
            role="tabpanel"
            aria-labelledby="tab-order"
          >
            <OrderHome />
          </article>
        )}

        {relatedLink === "CaseTransfer" && (
          <article
            className="tab-pane fade show active"
            id="panel-case-transfer"
            role="tabpanel"
            aria-labelledby="tab-case-transfer"
          >
            <CaseTransferParentHome />
          </article>
        )}
      </section>
    </main>
  );
};

export default DrtCaseCauseParent;
